import { forwardRef } from "react";

import Table from "react-bootstrap/Table";

import { MedicalAttendanceResumeByProfessional } from "@/services/sintegrada/attendanceReport/getMedicalAttendanceResumeByProfessional";
import { MedicalAttendanceTypeEnum } from "@/utils/enums/sintegrada/medicalAttendance/MedicalAttendanceTypeEnum";
import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	isLoading?: boolean;
	data: MedicalAttendanceResumeByProfessional;
};

export const MedicalAttendanceResumeByProfessionalTable = forwardRef<HTMLTableElement, Props>(
	({ isLoading, data }, ref) => {
		const hasData = Boolean(Object.keys(data).length);

		return (
			<Table id="total-table" ref={ref}>
				<thead>
					<tr className="fw-bold">
						<th>Profissional</th>
						<th>Total de 1° atendimentos</th>
						<th>Total de reavaliações</th>
						<th>Total de atendimentos</th>
					</tr>
				</thead>

				<tbody>
					{isLoading ? (
						<TableSkeletons numberOfCells={4} numberOfRows={10} />
					) : hasData ? (
						data.map((medicalAttendanceResumeByProfessional, index) => {
							const professionalName = medicalAttendanceResumeByProfessional.key.name;
							const requestedAttendanceTotal =
								medicalAttendanceResumeByProfessional.values?.find(
									(value) => value.key === MedicalAttendanceTypeEnum.REQUESTED
								)?.total || 0;
							const evaluatedAttendanceTotal =
								medicalAttendanceResumeByProfessional.values?.find(
									(value) => value.key === MedicalAttendanceTypeEnum.EVALUATED
								)?.total || 0;
							const attendanceTotal = medicalAttendanceResumeByProfessional.total;

							return (
								<tr key={`medical-attendance-resume-by-professional-${index}`}>
									<td>{professionalName}</td>
									<td>{requestedAttendanceTotal}</td>
									<td>{evaluatedAttendanceTotal}</td>
									<td>{attendanceTotal}</td>
								</tr>
							);
						})
					) : (
						<tr>
							<td colSpan={12} className="text-center text-black-50 fw-bold">
								Nenhum resultado encontrado
							</td>
						</tr>
					)}
				</tbody>
			</Table>
		);
	}
);
